import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { v4 as uuid } from 'uuid';
import s from './MLTextField.module.css';
import MLIcon from '../MLIcon/MLIcon';

function MLTextField(props) {
  const {
    id,
    name,
    containerClassName,
    className,
    type,
    placeholder,
    disabled,
    labelledBy,
    invalidError,
    hasError,
    errorMessages,
    focus,
    value,
    onChange,
    readOnly,
    inputRef,
    iconType,
    iconClassName,
    testId,
    iconOnClick,
    min,
    max,
    onBlur,
    ariaLabel,
    maxLength,
    onKeyPress,
  } = props;

  const errorClass = hasError
    ? s.MLTextFieldInputError
    : '';

  const textFieldId = id || uuid();
  const invalidErrorClass = invalidError ? s.invalidError : '';
  const onBlurInternal = (e) => {
    if (onBlur) onBlur(e);
  };
  const onChangeInternal = (e) => {
    if (onChange) onChange(e, e.target.value);
  };

  return (
    <div className={`${s.MLTextFieldContainer} ${containerClassName}`}>
      <input
        id={textFieldId}
        className={`${s.MLTextFieldInput} ${className} ${errorClass} ${invalidErrorClass}`}
        type={type}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        aria-labelledby={labelledBy}
        readOnly={readOnly}
        value={value}
        onChange={onChangeInternal}
        autoFocus={focus}
        ref={inputRef}
        data-test-id={testId}
        min={min}
        max={max}
        maxLength={maxLength}
        onBlur={onBlurInternal}
        aria-label={ariaLabel || ''}
        onKeyPress={onKeyPress}
      />
      {
        hasError &&
        _.map(errorMessages, (errorMessage, i) => (
          <div className={s.MLTextFieldErrorText} key={i}>
            <span>{errorMessage}</span>
          </div>
        ))
      }
      {iconType && <MLIcon type={iconType} onClick={iconOnClick} className={`${s.iconDefaults} ${iconClassName}`} />}
    </div>
  );
}

MLTextField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  labelledBy: PropTypes.string,
  readOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  focus: PropTypes.bool,
  errorMessages: PropTypes.array,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  inputRef: PropTypes.object,
  iconType: PropTypes.string,
  iconOnClick: PropTypes.func,
  iconClassName: PropTypes.string,
  invalidError: PropTypes.object,
  testId: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  onBlur: PropTypes.func,
  maxLength: PropTypes.number,
  onKeyPress: PropTypes.func,
};

export default MLTextField;
